import React from 'react';
import { useTranslation } from 'react-i18next';
/**
 * Component that displays a loading overlay when leaving the conference.
 *
 * @returns {JSX.Element}
 */
export const LeavingOverlay = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: 'leaving-overlay' },
        React.createElement("div", { className: 'leaving-overlay__content' },
            React.createElement("div", { className: 'leaving-overlay__spinner' }),
            React.createElement("div", { className: 'leaving-overlay__text' }, t('dialog.leavingConference')))));
};
